import { Injectable } from '@angular/core';
import { UserRightsModel } from '../models/user-rights-model';

@Injectable({
  providedIn: 'root',
})
export class UserRightsService {
  userRightsDataModel: UserRightsModel[];
  constructor() {}

  // tslint:disable-next-line: typedef
  getUserRightsIsEnabledWithKey(rights?) {
    let result = null;
    this.userRightsDataModel = JSON.parse(this.getUserRight());
    if (
      this.userRightsDataModel != null ||
      this.userRightsDataModel.length > 0
    ) {
      result = this.userRightsDataModel.filter((x) => x.code === rights)[0]
        .isEnabled;
    }
    return result;
  }

  // tslint:disable-next-line: typedef
  public getUserRight() {
    return sessionStorage.getItem('RIGHT_INFOS');
  }
}
